import { getMessages } from '../../../../../../../../store/constants';

export const BOARD_SECTION_COLORS_HIDE = getMessages().getText('board_settings.colors.hide');
export const BOARD_SECTION_COLORS_SHOW = getMessages().getText('board_settings.colors.show');
export const BOARD_SECTION_COLORS_MODAL_CANCEL = getMessages().getText('common.cancel');
export const BOARD_SECTION_COLORS_MODAL_REMOVE = getMessages().getText('common.remove');
